import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';

import GlobalStyle from './styles/global';

import AppProvider from './hooks/index';
import VideoConferenceFloating from './pages/PacienteAtendimento/components/VideoConferenceFloating';

const App: React.FC = () => (
  <BrowserRouter>
    <AppProvider>
      <Routes />
      <VideoConferenceFloating />
    </AppProvider>
    <GlobalStyle />
  </BrowserRouter>
);

export default App;
